import { useQuery } from '@tanstack/react-query'
import { OperationIds } from '../../util'
import { OperationQueryParams } from '../../util/types'
import { readCollection } from './requests/read'
import { PlansCollectionResponse } from './types'
import { readPlansCollection } from '.'

type UseReadPlansParams = {
  enabled?: boolean
  queryParams: OperationQueryParams<OperationIds.ReadPlansBFFV1>
  workspaceUuid: string
}

type UseReadPlansOptions<T = PlansCollectionResponse> = UseReadPlansParams & {
  select?: (data: PlansCollectionResponse) => T
}

/**
 * Used outside `useQuery` as part of `ensureQueryData`
 */
export const getReadPlansQueryFn = ({
  query,
  workspaceUuid,
}: {
  query: UseReadPlansParams['queryParams']
  workspaceUuid: string
}) => {
  return {
    queryKey: readPlansCollection.queryKey({
      workspaceUuid,
      queryParams: query,
    }),
    queryFn: () =>
      readCollection({
        path: {
          workspace_id: workspaceUuid,
        },
        query,
      }),
  }
}

export const useReadPlans = <T = PlansCollectionResponse>({
  enabled,
  queryParams,
  select,
  workspaceUuid,
}: UseReadPlansOptions<T>) => {
  return useQuery({
    enabled,
    ...getReadPlansQueryFn({ query: queryParams, workspaceUuid }),
    select,
  })
}
